import React, { useState } from 'react';
import { Popover, Box, Typography, Paper } from '@mui/material';
import NoteIcon from '@mui/icons-material/Note';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import FlightIcon from '@mui/icons-material/Flight';
import AppsIcon from '@mui/icons-material/Apps';

const APPS = [
  { name: 'Hub', url: 'https://apps.joseph-lee.app', icon: AppsIcon, color: '#5c6bc0', bg: 'rgba(92,107,192,0.15)' },
  { name: 'Notepad', url: 'https://notepad.joseph-lee.app', icon: NoteIcon, color: '#26a69a', bg: 'rgba(38,166,154,0.15)' },
  { name: 'FoodList', url: 'https://foodlist.joseph-lee.app', icon: RestaurantIcon, color: '#ff7043', bg: 'rgba(255,112,67,0.15)' },
  { name: 'Recipes', url: 'https://recipebook.joseph-lee.app', icon: MenuBookIcon, color: '#66bb6a', bg: 'rgba(102,187,106,0.15)' },
  { name: 'Travel', url: 'https://travelplanner.joseph-lee.app', icon: FlightIcon, color: '#42a5f5', bg: 'rgba(66,165,245,0.15)' },
];

// When children are provided they become the clickable trigger.
// Without children a plain icon button is rendered instead.
export default function AppSwitcher({ children }) {
  const [anchor, setAnchor] = useState(null);
  const open = Boolean(anchor);

  const trigger = children ? (
    <Box
      onClick={e => setAnchor(e.currentTarget)}
      sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center',
        userSelect: 'none',
        '&:hover': { opacity: 0.8 },
        transition: 'opacity 0.15s',
      }}
    >
      {children}
    </Box>
  ) : (
    <Box
      onClick={e => setAnchor(e.currentTarget)}
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center',
        width: 32, height: 32, borderRadius: 1, cursor: 'pointer',
        color: 'text.secondary',
        '&:hover': { bgcolor: 'rgba(255,255,255,0.06)' },
      }}
    >
      <AppsIcon fontSize="small" />
    </Box>
  );

  return (
    <>
      {trigger}

      <Popover
        open={open}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        PaperProps={{
          sx: {
            mt: 0.5, p: 1.5,
            bgcolor: '#1a1a2e',
            border: '1px solid rgba(255,255,255,0.08)',
            borderRadius: 2,
            boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
          },
        }}
      >
        <Typography variant="caption" color="text.secondary"
          sx={{ display: 'block', mb: 1, px: 0.5, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
          Switch app
        </Typography>
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 1 }}>
          {APPS.map(({ name, url, icon: Icon, color, bg }) => (
            <Paper
              key={name}
              component="a"
              href={url}
              onClick={() => setAnchor(null)}
              sx={{
                p: 1.5, textAlign: 'center', cursor: 'pointer', textDecoration: 'none',
                bgcolor: bg, border: `1px solid ${color}33`, borderRadius: 2,
                transition: 'transform 0.15s',
                '&:hover': { transform: 'translateY(-2px)' },
              }}
            >
              <Icon sx={{ color, fontSize: 22, display: 'block', mx: 'auto', mb: 0.5 }} />
              <Typography variant="caption" sx={{ color, fontWeight: 600, lineHeight: 1.2, display: 'block' }}>
                {name}
              </Typography>
            </Paper>
          ))}
        </Box>
      </Popover>
    </>
  );
}
